import { makeStyles } from '@material-ui/styles'
import { royalBlue } from 'shared/theme/colors'

export const consoleTooltipStyles = makeStyles(() => ({
  tooltip: {
    padding: '24px 20px 28px',

    maxWidth: 'none !important',
    width: 340,

    background: '#D4F4FA',
    boxShadow: '0px 1px 3px rgba(0, 0, 0, 0.12)',
    borderRadius: 6,
  },
  infoIcon: {
    color: royalBlue,
    fontSize: 20,
    marginBottom: 3,
  },
}))
